import * as tslib_1 from "tslib";
import { Observable, of } from 'rxjs';
import { filter, tap } from 'rxjs/operators';
import { StorageService } from '../storage/storage.service';
export class LangInterceptorService {
    constructor(storage) {
        this.storage = storage;
    }
    expect(request, next) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this.storage) {
                const lang = yield of(this.storage.getLang()).pipe(filter(a => a !== undefined)).toPromise();
                if (this.storage.getLang().LangID !== undefined) {
                    const requestClone = request.clone({
                        setParams: {
                            LangID: this.storage.getLang().LangID
                        }
                    });
                    return next.handle(requestClone).toPromise();
                }
                else {
                    return next.handle(request).toPromise();
                }
            }
            else {
                return next.handle(request).toPromise();
            }
        });
    }
    intercept(request, next) {
        if (request.url.indexOf('RB-LANGUAGES') > -1) {
            return next.handle(request);
        }
        this.storage.loading = true;
        return Observable.fromPromise(this.expect(request, next)).pipe(tap(a => this.storage.loading = false));
    }
}
